$.fn.scrollToAnchor = function(offset = 0) {
  let self = this

  self.click(function() {
    var hash = $(this).attr('href');
    var targetTop = $(hash).offset().top;
    // targetTop -= $('.header').outerHeight(false);
    // if(!$('.header').hasClass('header--scrolling')){
    //   targetTop += ($.mlmi.mobile.isMobile ? 0 : 37);
    // }
    $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
    return false;
  });

  return function() {
    return self
  }()
};
